var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:(_vm.bindedStyles.mainContainer),attrs:{"id":"mainContainer"}},[(_vm.$apollo.loading)?_c('Loading'):[_c('v-card-actions',{staticClass:"overflow-x-auto"},[_c('v-spacer'),_c('v-btn',{staticClass:"rounded-sm",staticStyle:{"min-width":"0"},attrs:{"color":"error","title":_vm.$t('buttons_edit.deleteTitle'),"height":"36","width":"36","disabled":_vm.$apollo.loading || _vm.saving},on:{"click":_vm.deleteItem}},[_c('v-icon',[_vm._v("delete_outline")])],1),_c('v-btn',{staticClass:"rounded-sm px-4",style:({ border: `2px solid ${_vm.primaryColor}` }),attrs:{"outlined":"","title":_vm.$t('buttons_edit.deleteTitle'),"disabled":!_vm.dirty || _vm.saving},on:{"click":_vm.update}},[_c('v-icon',[_vm._v("undo")]),_vm._v(" "+_vm._s(_vm.$t('buttons_edit.undoBtn'))+" ")],1),_c('v-btn',{staticClass:"rounded-sm px-4",attrs:{"color":"primary","disabled":!_vm.dirty,"loading":_vm.$apollo.loading || _vm.saving},on:{"click":_vm.save}},[_vm._v(" "+_vm._s(_vm.$t('buttons_edit.saveBtn'))+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1),_c('v-divider'),_c('v-tabs-items',{staticStyle:{"background-color":"transparent"},model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},[_c('v-tab-item',{style:(_vm.bindedStyles.content),attrs:{"value":"component"}},[_c('Fields',{attrs:{"schema":{
            name: {
              type: 'string',
              label: _vm.$t('buttons_edit.schema.name.label'),
              description: _vm.$t('buttons_edit.schema.name.description'),
              sizeSmall: 12,
              newDesign: true
            },
            title: {
              type: 'string',
              label: _vm.$t('buttons_edit.schema.title.label'),
              description: _vm.$t('buttons_edit.schema.title.description'),
              sizeSmall: 12,
              optional: true,
              newDesign: true
            },
            roles: {
              type: 'roleSelect',
              __graphQLType: '[ID]',
              label: 'Roles',
              fieldOptions: {
                multi: true
              },
              optional: true,
              newDesign: true
            },
            buttonType: {
              type: 'select',
              label: _vm.$t('buttons_edit.schema.buttonType.label'),
              fieldOptions: {
                options: [
                  {
                    label: _vm.$t('buttons_edit.schema.buttonType.btn'),
                    value: 'button'
                  },
                  { label: 'HSM', value: 'hsm' },
                  {
                    label: _vm.$t('buttons_edit.schema.buttonType.post'),
                    value: 'postItemToUrl'
                  }
                ],
                sizeSmall: 12
              },
              newDesign: true
            }
          },"disabled":_vm.$apollo.loading || _vm.saving,"environment-variables":{ environmentId: _vm.environmentId },"validationErrors":{}},model:{value:(_vm.button),callback:function ($$v) {_vm.button=$$v},expression:"button"}})],1),_c('v-tab-item',{attrs:{"value":"appearance"}},[_c('div',{staticClass:"background pa-2"},[_c('p',[_vm._v(_vm._s(_vm.$t('buttons_edit.preview')))]),_c('div',{staticClass:"text-center py-6"},[_c('v-btn',{style:(_vm.button.largeHitbox && _vm.button.style !== 'fab'
                  ? { flex: '1' }
                  : {}),attrs:{"color":_vm.button.color || 'primary',"dark":_vm.button.color &&
                (_vm.button.style === 'normal' || _vm.button.style === 'fab'),"text":_vm.button.style === 'flat',"outlined":_vm.button.style === 'outline',"fab":_vm.button.style === 'fab',"x-large":_vm.button.largeHitbox}},[(_vm.button.icon)?_c('v-icon',{attrs:{"left":_vm.button.buttonText && _vm.button.style !== 'fab'},domProps:{"textContent":_vm._s(_vm.normalizedIcon)}}):_vm._e(),(_vm.button.buttonText && _vm.button.style !== 'fab')?_c('span',[_vm._v(" "+_vm._s(_vm.button.buttonText)+" ")]):_vm._e()],1)],1)]),_c('div',{style:(_vm.bindedStyles.content)},[_c('Fields',{attrs:{"schema":{
              color: {
                type: 'string',
                fieldType: 'color',
                label: _vm.$t('buttons_edit.schema.color.label'),
                description: _vm.$t('buttons_edit.schema.color.description'),
                optional: true,
                newDesign: true
              },
              buttonText: {
                type: 'string',
                label: _vm.$t('buttons_edit.schema.buttonText.label'),
                sizeLarge: 6,
                optional: true,
                newDesign: true
              },
              icon: {
                type: 'string',
                label: _vm.$t('buttons_edit.schema.icon.label'),
                description: _vm.$t('buttons_edit.schema.icon.description'),
                sizeLarge: 6,
                optional: true,
                newDesign: true
              },
              style: {
                type: 'select',
                label: _vm.$t('buttons_edit.schema.style.label'),
                fieldOptions: {
                  options: [
                    {
                      label: _vm.$t('buttons_edit.schema.style.normal'),
                      value: 'normal'
                    },
                    {
                      label: _vm.$t('buttons_edit.schema.style.flat'),
                      value: 'flat'
                    },
                    {
                      label: _vm.$t('buttons_edit.schema.style.outline'),
                      value: 'outline'
                    },
                    {
                      label: _vm.$t('buttons_edit.schema.style.fab'),
                      value: 'fab'
                    }
                  ]
                },
                newDesign: true
              },
              largeHitbox: {
                type: 'checkbox',
                label: _vm.$t('buttons_edit.schema.largeHitbox.label'),
                optional: true,
                newDesign: true
              }
            },"disabled":_vm.$apollo.loading || _vm.saving,"validationErrors":{}},model:{value:(_vm.button),callback:function ($$v) {_vm.button=$$v},expression:"button"}})],1)]),_c('v-tab-item',{style:(_vm.bindedStyles.content),attrs:{"value":"actions"}},[_c('Fields',{attrs:{"schema":{
            firstHook: {
              type: 'string',
              label: _vm.$t('buttons_edit.schema.firstHook.label'),
              fieldType: 'hookSelect',
              optional: true,
              newDesign: true
            },
            afterHooksIds: {
              type: 'array',
              label: _vm.$t('buttons_edit.schema.afterHook.label'),
              fieldType: 'hookSelect',
              fieldOptions: {
                multi: true
              },
              optional: true
            },
            lastHook: {
              type: 'string',
              label: _vm.$t('buttons_edit.schema.lastHook.label'),
              fieldType: 'hookSelect',
              optional: true,
              newDesign: true
            },
            requireConfirmation: {
              type: 'checkbox',
              label: _vm.$t('buttons_edit.schema.requireConfirmation.label'),
              optional: true,
              newDesign: true
            },
            confirmationText: {
              type: 'string',
              label: _vm.$t('buttons_edit.schema.confirmationText.label'),
              optional: true,
              newDesign: true,
              fieldOptions: {
                placeholder: _vm.$t(
                  'buttons_edit.schema.confirmationText.placeholder'
                )
              }
            },
            onSuccessMessage: {
              type: 'string',
              label: _vm.$t('buttons_edit.schema.onSuccessMessage.label'),
              optional: true,
              newDesign: true
            },
            onErrorMessage: {
              type: 'string',
              label: _vm.$t('buttons_edit.schema.onErrorMessage.label'),
              optional: true,
              newDesign: true
            }
          },"environmentVariables":{ environmentId: _vm.environmentId, buttonId: _vm.componentId },"disabled":_vm.$apollo.loading || _vm.saving,"validationErrors":{}},model:{value:(_vm.button),callback:function ($$v) {_vm.button=$$v},expression:"button"}}),_c('v-card-text',[_c('p',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.$t('buttons_edit.paramsToHook')))]),_c('KeyValueList',{attrs:{"array":"","keyLabel":_vm.$t('buttons_edit.params'),"keyField":"parameterName"},model:{value:(_vm.button.parameters),callback:function ($$v) {_vm.$set(_vm.button, "parameters", $$v)},expression:"button.parameters"}}),_c('v-alert',{staticClass:"primary--text text-body-2",attrs:{"dense":"","type":"info","color":"info-300"},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('v-icon',{staticClass:"align-self-start mr-2",attrs:{"color":"primary"}},[_vm._v("info")])]},proxy:true}])},[_c('span',{staticClass:"d-block font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('buttons_edit.note'))+" ")]),_vm._v(" "+_vm._s(_vm.$t('buttons_edit.noteDescrip'))+" ")]),_c('p',{staticClass:"background py-2 px-4 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('buttons_edit.result'))+" ")]),_c('div',{staticStyle:{"padding-left":"32px"}},[_c('ul',[_c('li',[_vm._v(" "+_vm._s(_vm.$t('buttons_edit.operations'))+" "),_c('v-text-field',{staticStyle:{"display":"inline-block","width":"4em"},attrs:{"min":"0","dense":"","type":"number"},model:{value:(_vm.button.itemNumberResult),callback:function ($$v) {_vm.$set(_vm.button, "itemNumberResult", $$v)},expression:"button.itemNumberResult"}}),_vm._v(" "+_vm._s(_vm.$t('buttons_edit.aftOpera'))+" ")],1),_c('li',[_vm._v(" "+_vm._s(_vm.$t('buttons_edit.hookResukt'))+" "),_c('v-text-field',{staticStyle:{"display":"inline-block","width":"4em"},attrs:{"dense":"","min":"0","type":"number"},model:{value:(_vm.button.hookResult),callback:function ($$v) {_vm.$set(_vm.button, "hookResult", $$v)},expression:"button.hookResult"}}),_vm._v(" "+_vm._s(_vm.$t('buttons_edit.aftOpera'))+" ")],1)])]),_c('p',{staticClass:"subtitle-1"},[_vm._v(" "+_vm._s(_vm.$t('buttons_edit.paramsToView'))+" ")]),_c('KeyValueList',{attrs:{"array":"","keyLabel":_vm.$t('buttons_edit.paramsResult'),"keyField":"parameterName","valueLabel":_vm.$t('buttons_edit.paramsView')},model:{value:(_vm.button.setViewParameters),callback:function ($$v) {_vm.$set(_vm.button, "setViewParameters", $$v)},expression:"button.setViewParameters"}}),_c('v-slide-y-transition',[(_vm.button.buttonType === 'postItemToUrl')?_c('TextInput',{key:"postItemToUrl",attrs:{"name":"postItemToUrl","schema":{
                label: _vm.$t('buttons_edit.schema.postItemToUrl.label'),
                description: _vm.$t(
                  'buttons_edit.schema.postItemToUrl.description'
                ),
                optional: true
              }},model:{value:(_vm.button.postItemToUrl),callback:function ($$v) {_vm.$set(_vm.button, "postItemToUrl", $$v)},expression:"button.postItemToUrl"}}):_vm._e()],1),_c('v-slide-y-transition',[(_vm.button.buttonType === 'hsm')?_c('Fields',{key:"hsm",attrs:{"schema":{
                hsmHookId: {
                  type: 'string',
                  label: 'HSM Hook ID',
                  fieldType: 'hookSelect',
                  sizeSmall: 12,
                  optional: true,
                  newDesign: true
                }
              },"environmentVariables":{ environmentId: _vm.environmentId, buttonId: _vm.componentId },"disabled":_vm.$apollo.loading || _vm.saving,"validationErrors":{}},model:{value:(_vm.button),callback:function ($$v) {_vm.button=$$v},expression:"button"}}):_vm._e()],1),_c('CheckBox',{attrs:{"name":"requireTwoFactor","schema":{
              label: _vm.$t('buttons_edit.schema.shouldStopHooksOnError.label'),
              optional: true,
              newDesign: true
            }},model:{value:(_vm.button.shouldStopHooksOnError),callback:function ($$v) {_vm.$set(_vm.button, "shouldStopHooksOnError", $$v)},expression:"button.shouldStopHooksOnError"}}),_c('CheckBox',{attrs:{"name":"requireTwoFactor","schema":{
              label: _vm.$t('buttons_edit.schema.requireTwoFactor.label'),
              optional: true,
              newDesign: true
            }},model:{value:(_vm.button.requireTwoFactor),callback:function ($$v) {_vm.$set(_vm.button, "requireTwoFactor", $$v)},expression:"button.requireTwoFactor"}}),_c('CheckBox',{attrs:{"name":"goBack","schema":{
              label: _vm.$t('buttons_edit.schema.goBack.label'),
              optional: true,
              newDesign: true
            }},model:{value:(_vm.button.goBack),callback:function ($$v) {_vm.$set(_vm.button, "goBack", $$v)},expression:"button.goBack"}}),_c('v-slide-y-transition',[(!_vm.button.goBack)?_c('TextInput',{attrs:{"name":"url","schema":{
                label: _vm.$t('buttons_edit.schema.url.label'),
                description: _vm.$t('buttons_edit.schema.url.description'),
                fieldOptions: {
                  placeholder: _vm.$t('buttons_edit.schema.url.placeholder')
                },
                optional: true,
                newDesign: true
              }},model:{value:(_vm.button.url),callback:function ($$v) {_vm.$set(_vm.button, "url", $$v)},expression:"button.url"}}):_vm._e()],1)],1)],1)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }